import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdf0d6b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fdf0d6b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf0d6b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf0d6b4')) {
      api.createRecord('fdf0d6b4', component.options)
    } else {
      api.reload('fdf0d6b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fdf0d6b4&scoped=true", function () {
      api.rerender('fdf0d6b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/customerReviewManage/index.vue"
export default component.exports